import { FC, useContext } from "react";
import getFormItem from '../hooks/getFormItem';
import { EditableRowContext } from './editableRow';
import { MainSubEdiTableCellProps } from '../interface';

const EditableCell: FC<MainSubEdiTableCellProps> = props => {
  const { editable, disabled, children, record, formItemProps,  ...restProps } = props;
  const form = useContext(EditableRowContext);
  return (
    <td {...restProps}>
      {
        editable ? (
          // @ts-ignore
          getFormItem(record, { ...formItemProps, disabled, form })
        ) : (
          <>{children}</>
        )
      }
    </td>
  );
};

export default EditableCell;
